export const WHATSAPP_NUMBER = "573137226319";
export const WHATSAPP_LINK = `https://wa.me/${WHATSAPP_NUMBER}`;
export const PHONE = "+57 313 722 6319";
export const PHONE_ALT = "+57 315 068 6971";
export const EMAIL = "transformadoresbucaramanga@gmail.com";
export const COMPANY = "Transformadores Bucaramanga";
export const LOCATION = "Barrio Gaitan, Cl. 13 Nte. #3 -26, Bucaramanga, Santander";
export const MAPS_LINK = "https://share.google/v65zc6Ops1V0nVPfW";

export const formatCOP = (n) =>
  new Intl.NumberFormat("es-CO", {
    style: "currency",
    currency: "COP",
    // COP exige mínimo 2 decimales en algunos entornos (ICU reducido);
    // fijamos min y max en 0 para evitar RangeError al prerenderizar.
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(n);

export const buildWhatsAppMessage = (text) =>
  `${WHATSAPP_LINK}?text=${encodeURIComponent(text)}`;
